import CardDots from "@/Components/DataDisplayCompoants/CardDots";
import { toWebp } from "@/utils/common";
import Image from "next/image";
import React from "react";

interface FutureProps {
  data?: any;
}

const Future = ({ data }: FutureProps) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";
  return (
    <section className="relative bg-background-white text-primary-text py-[56px] xl:py-25 md:py-[80px] overflow-hidden">
      {" "}
      <div className="container mx-auto px-4 text-center relative z-10">
        {/* Heading */}
        <h2 className="text-heading-3 font-bold text-primary-text xl:mb-[60px] mb-[40px] md:mt-[0px] max-w-[940px] mx-auto flex w-full" data-aos="fade">
          {data?.title}
        </h2>

{/* desktop */}
        <div className=" grid-cols-1 sm:grid-cols-3 gap-[30px] mx-auto xl:mb-[60px] mb-[40px] sm:grid hidden">
          {data?.cards?.future_cards?.map((card: any, index: number) => (
            <div
              key={card.id}
              className={`relative effect-card bg-gradient-to-tr 
              ${index === 1 ? "from-green-100 to-green-50 bg-[url(/images/about/fm-1.png)] sm:bg-[url(/images/about/f2.png)]" : "from-blue-100 to-blue-50 bg-[url(/images/about/fm-2.png)] sm:bg-[url(/images/about/f1.png)]"} 
              p-[56px_24px] 
              bg-[url(/images/about/f1.png)] bg-cover bg-center 
              aspect-square sm:h-auto h-[316px] min-[480px]:h-[316px] w-full`}
              data-aos="fade-up"
              data-aos-delay={`${200 * (index + 1)}`}
            >
              <p className="text-primary-text text-heading-5 font-bold w-full text-left">
                {card.title}
              </p>
              <CardDots />

              {card?.Image?.data?.attributes?.url && (
                <Image
                  alt={card.title}
                  src={toWebp(baseUrl + card?.Image?.data?.attributes?.url)}
                  width={203}
                  height={225}
                  className="absolute right-0 bottom-0 color-burn opacity-50 contrast-125 "
                />
              )}
            </div>
          ))}
        </div>

        {/* mobile */}
        <div className=" grid-cols-1 sm:grid-cols-3 gap-[30px] mx-auto xl:mb-[60px] mb-[40px] sm:hidden grid">
          {data?.cards?.future_cards?.map((card: any, index: number) => (
            <div
              key={card.id}
              className={`relative effect-card bg-gradient-to-tr 
        ${index === 1 ? "from-green-100 to-green-50 bg-[url(/images/about/fm-1.png)] sm:bg-[url(/images/about/f2.png)]" : "from-blue-100 to-blue-50 bg-[url(/images/about/fm-2.png)] sm:bg-[url(/images/about/f1.png)]"} 
        p-[56px_24px] 
        bg-[url(/images/about/f1.png)] bg-cover bg-center 
        aspect-square sm:h-auto h-[316px] min-[480px]:h-[316px] w-full`}
            >
              <p className="text-primary-text text-heading-5 font-bold w-full text-left">
                {card.title}
              </p>
              <CardDots />

              {card?.Image?.data?.attributes?.url && (
                <Image
                  alt={card.title}
                  src={toWebp(baseUrl + card?.Image?.data?.attributes?.url)}
                  width={203}
                  height={225}
                  className="absolute right-0 bottom-0 color-burn opacity-50 contrast-125 w-[222px] sm:[203px]"
                />
              )}
            </div>
          ))}
        </div>


        {/* Subheading */}
        <p className="text-heading-5 font-semibold text-primary-text  xl:mb-[60px] mb-[40px] max-w-[940px] mx-auto" data-aos="fade-up" data-aos-delay="200" >
          {data?.paragraph_1}
        </p>
        <p className="text-heading-5 font-semibold text-primary-text  xl:mb-[60px] mb-[40px] max-w-[940px] mx-auto" data-aos="fade-up" data-aos-delay="400" >
          {data?.paragraph_2}
        </p>

        <p className="text-heading-5 font-semibold text-primary-text  xl:mb-[60px] mb-[40px] max-w-[940px] mx-auto" data-aos="fade-up" data-aos-delay="600">
          {data?.paragraph_3}
        </p>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 xl:mb-[60px] mb-[40px]">
          {data?.cards_2?.future_cards?.map((card: any, index: number) => (
            <div
              key={card.id}
              className={`${index === 1 ? "border-green-100" : "border-blue-100"
                } border-1 bg-white flex flex-col justify-between`}
              data-aos="fade-up"
              data-aos-delay={`${800 + index * 200}`}
            >
              <div className="text-heading-5 font-bold text-primary-text text-left xl:p-[32px_20px_24px_20px] p-[24px_16px_16px_16px] xl:min-h-[181px] lg:min-h-[165px] card-feature">
                {card.title}
              </div>
              <Image
                height={212}
                width={358}
                src={toWebp(baseUrl + card?.Image?.data?.attributes?.url)}
                alt={card.title}
                className={`w-full xl:h-[212] md:h-[133px] h-[170px] object-cover ${index === 1 ? "border-green-100" : "border-blue-100"
                  } border-l-[32px] mt-auto`}
              />
            </div>
          ))}
        </div>

        {/* Closing Line */}
        <p className="text-heading-5 font-semibold text-primary-text mb-[0] max-w-[940px] mx-auto" data-aos="fade-up" data-aos-delay="200">
          {data?.paragraph_4}
        </p>
      </div>
    </section>
  );
};

export default Future;
